module.exports = __webpack_public_path__ + "img/fontumi-logo-complete.3a3fe0f2.png";